var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFlowerRotate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 61.35 41.84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#95c11f;}.cls-3{fill:#4a671e;}.cls-4,.cls-5{fill:#db5583;}.cls-5{opacity:0.5;mix-blend-mode:multiply;}.cls-6{fill:#f7bd2e;}.cls-7{fill:#ffec55;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "saturnia-flower-rotate_1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Camada_2",
    "data-name": "Camada 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "flower-rotate"
  }, /*#__PURE__*/React.createElement("g", {
    id: "flower-two"
  }, /*#__PURE__*/React.createElement("path", {
    id: "caule",
    className: "cls-2",
    d: "M47.58,25.67a1.25,1.25,0,0,1-1.26-1.26,21.91,21.91,0,0,0-43.82,0,1.25,1.25,0,1,1-2.5,0,24.42,24.42,0,0,1,48.83,0A1.25,1.25,0,0,1,47.58,25.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "folha",
    className: "cls-3",
    d: "M18.51,5A13.25,13.25,0,0,0,30,15a.31.31,0,0,0,.35-.37c-.41-1.93-2.63-9.95-11.55-10A.31.31,0,0,0,18.51,5Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "petala"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M54.13,32.29a16.21,16.21,0,0,1-1.75-.12,14.59,14.59,0,0,1,.88,1.51c1.69,3.36,1.85,6.74.42,7.82a2.26,2.26,0,0,1-.26.16c-1.7.85-4.53-1.33-6.31-4.89a13.57,13.57,0,0,1-.63-1.43c-.25.44-.52.89-.83,1.33-2.28,3.26-5.39,5-6.95,3.93s-1-4.62,1.3-7.87l.41-.55h-.68c-4,0-7.19-1.59-7.18-3.49s3.25-3.42,7.22-3.4a16.21,16.21,0,0,1,1.75.12,14.59,14.59,0,0,1-.88-1.51c-1.79-3.55-1.86-7.12-.16-8s4.53,1.34,6.31,4.89a12.85,12.85,0,0,1,.63,1.44,14.73,14.73,0,0,1,.83-1.34c2.28-3.26,5.39-5,7-3.93s1,4.62-1.3,7.88c-.14.18-.27.37-.41.54h.68c4,0,7.19,1.59,7.18,3.49S58.1,32.31,54.13,32.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M53.68,41.5a2.26,2.26,0,0,1-.26.16c-1.7.85-4.53-1.33-6.31-4.89a13.57,13.57,0,0,1-.63-1.43c-.25.44-.52.89-.83,1.33-2.28,3.26-5.39,5-6.95,3.93s-1-4.62,1.3-7.87l.41-.55h-.68c-4,0-7.19-1.59-7.18-3.49s3.25-3.42,7.22-3.4a16.21,16.21,0,0,1,1.75.12,14.59,14.59,0,0,1-.88-1.51c-1.79-3.55-1.86-7.12-.16-8Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "miolo"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M52.58,28.64A5.64,5.64,0,0,1,49.21,34a5.7,5.7,0,0,1-2.11.47,5.64,5.64,0,1,1,5.48-5.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M50.74,30a5.64,5.64,0,0,1-1.53,4,5.7,5.7,0,0,1-2.11.47,5.63,5.63,0,0,1-4.25-9.49A5.47,5.47,0,0,1,45,24.47,5.63,5.63,0,0,1,50.74,30Z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFlowerRotate);
export default __webpack_public_path__ + "static/media/icon-flower-rotate.b356b90a8a7fa8e6becfc58887fe14c3.svg";
export { ForwardRef as ReactComponent };